import React from 'react';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

type TProps = {
  handleDateSelect: (date: Date | null) => void;
  handleBlur: () => void;
  selectedDate: Date | null;
  placeHolder: string;
  label: string;
  minDate?: Date | null;
  error?: any;
  errorText?: any;
};
export default function MaterialUIPickers({
  handleDateSelect,
  handleBlur,
  selectedDate,
  placeHolder,
  label,
  minDate,
  error,
  errorText,
}: TProps) {
  const handleDateChange = (date: Date | null) => {
    handleDateSelect(date);
  };
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        inputVariant="outlined"
        variant="inline"
        label={label}
        clearable
        value={selectedDate}
        placeholder={placeHolder}
        onChange={handleDateChange}
        onBlur={handleBlur}
        minDate={minDate || new Date()}
        format="dd/MM/yyyy"
        InputLabelProps={{ shrink: true }}
        error={error}
        helperText={errorText}
      />
    </MuiPickersUtilsProvider>
  );
}
